var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPlug1Light1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 244.47 111.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#739c20;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#dbd100;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6",
    className: "cls-1",
    d: "M51.53,33A25.79,25.79,0,0,0,0,34.63L.1,80.25H13.61V60.54H24A27.5,27.5,0,0,0,51.53,33Zm-27,14H13.61V34.63A12.23,12.23,0,0,1,38,33.53,13.52,13.52,0,0,1,24.51,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    className: "cls-1",
    d: "M126.83,54.54a12.31,12.31,0,0,1-24.62,0V8.82H88.81V54.54a25.71,25.71,0,0,0,51.42,0V8.82h-13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    className: "cls-1",
    d: "M217.46,37.83H182.05V51.24h21.31a22,22,0,1,1-21-28.72,21.78,21.78,0,0,1,15.4,6.31l9.71-9.71a35.73,35.73,0,1,0,10.6,25.42,36.33,36.33,0,0,0-.6-6.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    className: "cls-1",
    d: "M56.57,0V63.36A25.7,25.7,0,0,0,82.28,89.07V75.56a12.18,12.18,0,0,1-12.2-12.2V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    className: "cls-2",
    d: "M244.47,89.07V25.71A25.71,25.71,0,0,0,218.75,0V13.51A12.19,12.19,0,0,1,231,25.71V89.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    className: "cls-1",
    d: "M18.44,110.1a3.27,3.27,0,0,1-2.44-1,3.62,3.62,0,0,1,0-5,3.42,3.42,0,0,1,4.89,0,3.65,3.65,0,0,1,0,5A3.28,3.28,0,0,1,18.44,110.1Zm0-8.06a4.52,4.52,0,0,0-4.58,4.53,4.36,4.36,0,0,0,1.33,3.2,4.41,4.41,0,0,0,3.25,1.32,4.46,4.46,0,0,0,3.27-1.32,4.55,4.55,0,0,0,0-6.41A4.41,4.41,0,0,0,18.44,102Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    className: "cls-1",
    d: "M29.59,111h2.57v-3.38h3.67v-2.15H32.16v-1.07h4.2v-2.18H29.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    className: "cls-1",
    d: "M43.25,108.79a1.28,1.28,0,0,1-1-.37,1.38,1.38,0,0,1-.38-1.09v-5.15H39.33v5.3a3.37,3.37,0,0,0,1.1,2.69,4.1,4.1,0,0,0,2.82,1,4.14,4.14,0,0,0,2.83-1,3.39,3.39,0,0,0,1.09-2.69v-5.3H44.59v5.15a1.45,1.45,0,0,1-.36,1.09A1.36,1.36,0,0,1,43.25,108.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    className: "cls-1",
    d: "M53.1,111h2.57v-6.6h2.75v-2.18H50.34v2.18H53.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    className: "cls-1",
    d: "M65.51,108.79a1.3,1.3,0,0,1-1-.37,1.38,1.38,0,0,1-.38-1.09v-5.15H61.6v5.3a3.34,3.34,0,0,0,1.1,2.69,4.05,4.05,0,0,0,2.81,1,4.17,4.17,0,0,0,2.84-1,3.42,3.42,0,0,0,1.08-2.69v-5.3H66.86v5.15a1.45,1.45,0,0,1-.37,1.09A1.34,1.34,0,0,1,65.51,108.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    className: "cls-1",
    d: "M73.08,111h2.58v-1.84c.77,0,1.32,0,1.69,0l1,1.86h2.94l-1.64-2.62a3,3,0,0,0,1-1.19,3.38,3.38,0,0,0,.36-1.5,3.31,3.31,0,0,0-1.06-2.5,4.33,4.33,0,0,0-3-1H73.08Zm2.58-4v-2.57H77a1.3,1.3,0,0,1,1,.37,1.27,1.27,0,0,1,.36.92,1.22,1.22,0,0,1-.36.9,1.29,1.29,0,0,1-1,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    className: "cls-1",
    d: "M86.86,106.57a2.2,2.2,0,0,1,.59-1.57,1.88,1.88,0,0,1,1.42-.63,1.94,1.94,0,0,1,1.47.61,2.52,2.52,0,0,1,0,3.19,2,2,0,0,1-2.92,0,2.33,2.33,0,0,1-.56-1.6Zm-2.69,0a4.37,4.37,0,0,0,1.32,3.24,4.56,4.56,0,0,0,3.38,1.31,4.61,4.61,0,0,0,3.41-1.31,4.65,4.65,0,0,0,0-6.47,4.7,4.7,0,0,0-3.41-1.3,4.63,4.63,0,0,0-3.38,1.3A4.38,4.38,0,0,0,84.17,106.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    className: "cls-1",
    d: "M99.88,111H101l.81-1.71h5.36L108,111h1.12L105,102.18H104Zm2.33-2.6,1.5-3.08c.25-.54.52-1.16.78-1.86l.8,1.85,1.48,3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    className: "cls-1",
    d: "M111.71,106.57a4.35,4.35,0,0,0,1.32,3.2,4.67,4.67,0,0,0,6.51,0l-.69-.75a3.41,3.41,0,0,1-2.56,1.08,3.24,3.24,0,0,1-2.44-1,3.6,3.6,0,0,1,0-5,3.31,3.31,0,0,1,2.49-1,3.37,3.37,0,0,1,2.32.9l.66-.75a4.64,4.64,0,0,0-6.29.18,4.37,4.37,0,0,0-1.32,3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    className: "cls-1",
    d: "M127.19,110.1a3.26,3.26,0,0,1-2.44-1,3.62,3.62,0,0,1,0-5,3.42,3.42,0,0,1,4.89,0,3.65,3.65,0,0,1,0,5A3.28,3.28,0,0,1,127.19,110.1Zm0-8.06a4.52,4.52,0,0,0-4.58,4.53,4.36,4.36,0,0,0,1.33,3.2,4.67,4.67,0,0,0,6.51,0,4.54,4.54,0,0,0,0-6.41A4.41,4.41,0,0,0,127.19,102Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    className: "cls-1",
    d: "M135.83,111h1.08V103.9l.16.26.48.7c.2.3.4.57.61.83l4.06,5.27h1.09v-8.78h-1.09v7.11l-.16-.26-.43-.66a8.39,8.39,0,0,0-.55-.74l-4.2-5.45h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    className: "cls-1",
    d: "M150.26,111h1.09v-7.82h3.25v-1H147v1h3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    className: "cls-1",
    d: "M158.31,111h6.84v-1h-5.76v-3.26h5.2v-.94h-5.2v-2.66H165v-1h-6.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    className: "cls-1",
    d: "M168.37,106.57a4.32,4.32,0,0,0,1.33,3.2,4.66,4.66,0,0,0,6.5,0l-.69-.75A3.41,3.41,0,0,1,173,110.1a3.26,3.26,0,0,1-2.44-1,3.62,3.62,0,0,1,0-5,3.31,3.31,0,0,1,2.49-1,3.37,3.37,0,0,1,2.32.9l.66-.75a4.63,4.63,0,0,0-6.28.18,4.34,4.34,0,0,0-1.33,3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    className: "cls-1",
    d: "M179.88,111h6.84v-1H181v-3.26h5.21v-.94H181v-2.66h5.57v-1h-6.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    className: "cls-1",
    d: "M193,111h1.11l.81-1.71h5.37l.81,1.71h1.13l-4.15-8.78h-.93Zm2.33-2.6,1.49-3.08c.26-.54.53-1.16.79-1.86l.8,1.85,1.47,3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    className: "cls-1",
    d: "M209.43,102a4.43,4.43,0,0,0-3.25,1.32,4.53,4.53,0,0,0,0,6.41,4.43,4.43,0,0,0,3.25,1.32,4.56,4.56,0,0,0,2.83-.93l.86.85.7-.7-.85-.84a4.43,4.43,0,0,0,1-2.9,4.52,4.52,0,0,0-4.58-4.53Zm0,8.06a3.27,3.27,0,0,1-2.44-1,3.62,3.62,0,0,1,0-5,3.42,3.42,0,0,1,4.89,0,3.45,3.45,0,0,1,1,2.51,3.71,3.71,0,0,1-.67,2.13L211,107.52l-.69.69,1.18,1.19a3.28,3.28,0,0,1-2.08.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    className: "cls-1",
    d: "M221.55,111.09a3.59,3.59,0,0,0,2.58-1,3.29,3.29,0,0,0,1.05-2.53v-5.39H224.1v5.39a2.41,2.41,0,0,1-.73,1.82,2.55,2.55,0,0,1-1.82.71,2.49,2.49,0,0,1-1.8-.71,2.38,2.38,0,0,1-.74-1.82v-5.39h-1.09v5.39A3.26,3.26,0,0,0,219,110.1,3.55,3.55,0,0,0,221.55,111.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    className: "cls-1",
    d: "M229.51,111h1.09v-8.78h-1.09Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlug1Light1);
export default __webpack_public_path__ + "static/media/logo-plug1-light-1.3030d81ffbd00a1231bbfe4dd163b596.svg";
export { ForwardRef as ReactComponent };